import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { Program, web3 } from '@coral-xyz/anchor';
import { Args, Flags } from '@oclif/core';
import { Queue, State } from '@switchboard-xyz/on-demand';

async function rmMrOracleIx(params: {
  program: Program;
  authority: web3.PublicKey;
  queueKey: web3.PublicKey;
  oracleKey: web3.PublicKey;
}): Promise<web3.TransactionInstruction> {
  const program = params.program;
  const queue = new Queue(params.program, params.queueKey);
  const queueData = await queue.loadData();
  const oracleIdx = queueData.oracleKeys.findIndex((o: web3.PublicKey) =>
    o.equals(params.oracleKey)
  );
  if (oracleIdx === -1) {
    throw new Error('oracle not found in queue');
  }
  const stateKey = State.keyFromSeed(program);
  const ix = await program.instruction.queueGarbageCollect(
    { idx: oracleIdx },
    {
      accounts: {
        queue: params.queueKey,
        oracle: params.oracleKey,
        authority: params.authority,
        state: stateKey,
      },
    }
  );
  return ix;
}

export default class QueueRmOracle extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Add allowed measurement to the queue';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    oracle: Flags.string({
      description: 'oracle key',
      required: true,
    }),
  };

  static args = {
    queue: Args.string({
      description: 'The queue account to configure',
      required: true,
    }),
  };

  async run() {
    const { args, flags } = await this.parse(
      this.constructor as typeof QueueRmOracle
    );

    const program = await this.program;

    const ix = await rmMrOracleIx({
      authority: this.keypair.publicKey,
      program: program,
      queueKey: new web3.PublicKey(args.queue),
      oracleKey: new web3.PublicKey(flags.oracle),
    });

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to configure queue mrEnclave');
  }
}
